import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trustee',
  templateUrl: './trustee.component.html',
  styleUrls: ['./trustee.component.css']
})
export class TrusteeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
